import React from 'react';
import { renderTspContent } from './TspManualContent';
import { renderUspContent } from './UspManualContent';

const PLACEHOLDER = (
  <div className="menual-panel-body-inner">
    <p className="txt">준비 중입니다.</p>
  </div>
);

export function renderPanelContent(portal: string, key: string): React.ReactNode {
  switch (portal) {
    case 'PORTAL_TSP': return renderTspContent(key);
    case 'PORTAL_USP': return renderUspContent(key);
    default: return PLACEHOLDER;
  }
}
